import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgLock = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.23077C7.33268 1.23077 6.69269 1.51172 6.22083 2.01182C5.74896 2.51191 5.48387 3.19019 5.48387 3.89744V6.35897C5.48387 6.69884 5.22391 6.97436 4.90323 6.97436C4.58254 6.97436 4.32258 6.69884 4.32258 6.35897V3.89744C4.32258 2.86377 4.71002 1.87244 5.39967 1.14153C6.08932 0.410621 7.02469 0 8 0C8.97531 0 9.91068 0.410621 10.6003 1.14153C11.29 1.87244 11.6774 2.86377 11.6774 3.89744V6.35897C11.6774 6.69884 11.4175 6.97436 11.0968 6.97436C10.7761 6.97436 10.5161 6.69884 10.5161 6.35897V3.89744C10.5161 3.19019 10.251 2.51191 9.77917 2.01182C9.30731 1.51172 8.66732 1.23077 8 1.23077Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 6.35897C2 6.01911 2.25996 5.74359 2.58065 5.74359H13.4194C13.74 5.74359 14 6.01911 14 6.35897V13.7436C14 14.342 13.7757 14.916 13.3764 15.3391C12.9771 15.7623 12.4356 16 11.871 16H4.12903C3.56438 16 3.02285 15.7623 2.62358 15.3391C2.22431 14.916 2 14.342 2 13.7436V6.35897ZM3.16129 6.97436V13.7436C3.16129 14.0156 3.26325 14.2765 3.44474 14.4688C3.62622 14.6612 3.87237 14.7692 4.12903 14.7692H11.871C12.1276 14.7692 12.3738 14.6612 12.5553 14.4688C12.7368 14.2765 12.8387 14.0156 12.8387 13.7436V6.97436H3.16129Z"
    />
    <path d="M9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgLock)
const IconSvgLock = createIcon(ForwardRef, 'SvgLock')
export default IconSvgLock
